import { connectToDatabase } from "@/components/Server/Database/MongoDB";
import StudentDashboardLayout from "@/components/Student/DashboardLayout";
import Reviews from "@/components/Student/Reviews";
import PageHead from "@/pages/Head";

const StudentReviews = ({ info }) => {
  return (
    <>
      <PageHead title="Student Reviews Course - Online Courses & Education Powered By THEWEBVALE" />
      <StudentDashboardLayout brand={JSON.parse(info)} sidebar={true}>
        <Reviews />
      </StudentDashboardLayout>
    </>
  );
};

export const getServerSideProps = async (context) => {
  const domainName = context.req ? context.req.headers.host : null;

  const { db } = await connectToDatabase();

  const info = await db.collection("partners").findOne({
    key: process.env.DEFAULT || domainName,
  });

  if (!info) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      info: JSON.stringify(info),
    },
  };
};
export default StudentReviews;
